export default __webpack_public_path__ + "55c8b42972c1e3913700f59bc99975e7.jpg";